<template>
     <!-- Navbar -->
  <nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
      </li>
      <li class="nav-item d-none d-sm-inline-block">
        <a href="#" class="nav-link text-secondary">{{empresa}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span v-if="!produccion" class="text-danger">============ VERSION DE PRUEBA ============</span></a>
      </li>
    </ul>

    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <!-- Navbar Search -->
      <li class="nav-item">
        <a href="#" class="nav-link">{{sucursal}}</a>
      </li>
      <li class="nav-item">    
        <a  href="#" class="nav-link" @click="logout()"><i class="fas fa-sign-out-alt"></i> Salir</a>
      </li>
    </ul>
  </nav>
  <!-- /.navbar -->
</template>

<script>
  export default{
    data(){
      return{
        empresa:'',
        sucursal:'',
        produccion:true,
      }
    },
    methods:{
        async logout() {
        try {
            const refresh = localStorage.getItem('refresh');
            if (refresh) {
                await this.$axios.post('api/auth/logout/', { refresh });
            }
        } catch (error) {
            console.error(error);
        } finally {
            // Limpiar localStorage
            localStorage.removeItem('access');
            localStorage.removeItem('refresh');
            localStorage.removeItem('username');
            localStorage.removeItem('idusuario');
            localStorage.removeItem('grupo_id');
            localStorage.removeItem('grupo_nombre');
            localStorage.removeItem('idSucursal');
            localStorage.removeItem('sucursal');
            localStorage.removeItem('permisoDscto');
            localStorage.removeItem('empresa');
            localStorage.removeItem('idEmpresa');
            localStorage.removeItem('rucEmpresa');
            localStorage.removeItem('produccion');
            localStorage.removeItem('db_name');

            // Limpiar headers de Axios
            delete this.$axios.defaults.headers.common['Authorization'];

            // Redirigir usando Vue Router
            this.$router.push('/login');
        }
    }
    },
    mounted() {
        const value = localStorage.getItem('produccion')
        this.produccion = value === 'true'
        this.empresa = localStorage.getItem('empresa')
        this.sucursal = localStorage.getItem('sucursal')
        console.log('produccion '+this.produccion)
    },
  }
</script>